import React from 'react';
import styled from 'styled-components';
import seasonal from '../assets/images/snow.gif';
import Checkbox from './forms/Checkbox';
import { useGlobalState } from './stateProvider/StateProvider';

const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    pointer-events: none;
    position: absolute;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100svw;
        height: 100svh;
        background-image: url(${seasonal});
        pointer-events: none;
        opacity: 0.3;
        overflow: hidden;
    }
`;

const Seasonal = ({ ...props }) => {
    const { state: { seasonal } } = useGlobalState();
    //return seasonal ? <Wrapper /> : null;
    return null;
}

export const SeasonalToggle = ({ ...props }) => {
    const { state: { seasonal }, toggleSeasonal } = useGlobalState();

    return typeof seasonal === 'boolean' ? (
        <Checkbox
            label='Seasonal Effects'
            checked={seasonal}
            onChange={(e) => toggleSeasonal()}
            standalone
        />
    ) : null
}

export default Seasonal;
